import { Client } from "creso-core/types";
import { getAutofillSourceMessage } from "creso-core/utils";
import { AutofillSource } from "creso-core/zod";
import { BookCheckIcon } from "lucide-react";

export function AutofilledData({
  client,
  autofillSource,
}: {
  client?: Client;
  autofillSource?: AutofillSource;
}) {
  if (!autofillSource) return null;

  return (
    <div className="flex flex-col w-full rounded-lg text-xs border border-border gap-2 p-3">
      <div className="items-center flex gap-2 text-constructive">
        <BookCheckIcon className="size-4" />
        <span className="font-semibold">Form auto filled</span>
      </div>
      <span className="text-muted-foreground">
        {getAutofillSourceMessage(client?.name, autofillSource)}
      </span>
    </div>
  );
}
